<h1>Graph Details</h1>
<br>
  @if (graphId=='contractExpirations') {
    <div>
      <h3>{{nameOfDrillDown}}</h3>
      <ag-grid-angular
        style="width: 100%; height: 150px;"
        class="ag-theme-balham"
        
        [rowData]="contractData"
        [columnDefs]="contractColumns"
        (gridReady)="onGridReady($event)"
        (cellClicked)='onContractCellClicked($event)'
        >
      </ag-grid-angular>
    </div>
  }

  @if (graphId=='baaReviewDates') {
    <div>
      <h3>{{nameOfDrillDown}}</h3>
      <ag-grid-angular
        style="width: 100%; height: 150px;"
        class="ag-theme-balham"
        
        [rowData]="contractData"
        [columnDefs]="baaColumns"
        (gridReady)="onGridReady($event)"
        (cellClicked)='onBaaCellClicked($event)'
        >
      </ag-grid-angular>
    </div>
  }

  @if (graphId=='annualValues') {
    <div>
      <h3>{{nameOfDrillDown}}</h3>
      <ag-grid-angular
        style="width: 100%; height: 150px;"
        class="ag-theme-balham"
        
        [rowData]="contractData"
        [columnDefs]="contractColumns"
        (gridReady)="onGridReady($event)"
        (cellClicked)='onContractCellClicked($event)'
        >
      </ag-grid-angular>
    </div>
  }